// extracted by mini-css-extract-plugin
export default {"header":"Header_header__js3bW","logo":"Header_logo__KgL4L"};